
import "./main.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

import { useEffect } from "react";

/* imagens */
import gptimg1 from "../assets/chatgpt_image1.png";
import gptimg2 from "../assets/chatgpt_image2.png";

export default function Main() {

    useEffect(() => { window.scrollTo(0, 0); }, []);

    return(
        <div className="context">
            
            <Header access={0}></Header>
            
            <div className="content">
                <span className="ft_topico">Você sabe o que é um agente de IA?</span>
                <span className="ft_descricao">Um agente de IA é um programa de software que usa a inteligência artificial para realizar tarefas de forma autônoma</span>
                <span className="ft_descricao">E se eu te disser que esse mesmo colaborador não precisa de salário e nem benefícios, não tira folgas e nem férias.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">A inteligência artificial pode te ajudar</span>
                <span className="ft_descricao">Com o grande avanço das tecnologias de inteligência artificial (IA's), gradativamente, as tarefas rotineiras estão cada vez mais sendo introduzidas no mercado e sendo delegadas a robôs, que por sua vez, executam estas tarefas com maestria, pontualidade e sem descanso e remuneração.</span>
                <span className="ft_descricao">Inevitavelmente e irretroativamente, as IA's chegaram para ficar e inicialmente estão ocupando um espaço na execução de tarefas operacionais, onde sob alguma supervisão, elas conseguem desempenhar um papel eficaz e preciso.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">Mas onde eu entro nessa história?</span>
                <span className="ft_descricao">Se você tem ou trabalha em um estabelecimento onde exija atendimento ao público (seja clientes, pacientes e etc) você necessariamente terá que executar ou contratar alguém que execute as tarefas administrativas, tais como: prestar informações sobre seu trabalho ou atendimento, sobre suas especialidades, consultar sua agenda e ver disponibilidades, marcar e remarcar horários, mostrar cardápios, informar valores e etc.</span>
                <span className="ft_descricao">E é nesse contexto das tarefas administrativas, que podemos ajudar você.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">Somos uma empresa que comercializa agentes de IA</span>
                <span className="ft_descricao">Temos soluções para atender a determinados ramos de atividades com nossos agentes, onde eles farão todo o primeiro contato com os clientes, interagindo de forma fluída e não mecânizada.</span>
                <span className="ft_descricao">Nossos agentes são personalizáveis através dessa plataforma e com valores de mensalidade muito acessíveis.</span>
                <span className="space"></span>
                <span className="space"></span>
                <span className="ft_topico">E por onde eu começo?</span>
                <span className="ft_descricao">Clique em Planos e confira se alguma das especialidades dos nossos agentes lhe atende.</span>
                <span className="ft_descricao">Clique em Cadastrar, faça seu cadastro com pouquíssimas informações, após concluir o cadastro, clique nem Entrar, faça seu login e você será direcionado a área do cliente.</span>
                <span className="ft_descricao">Na área do cliente você poderá criar e configurar seu agente de forma personalizada. Poderá testá-lo por 15 dias de forma totalmente gratuíta.</span>
                <img className="main_image2" src={gptimg2}></img>
                <span className="space"></span>
                <span className="space"></span>
                <span className="space"></span>
            </div>
            
            <Footer access={0}></Footer>

        </div>
    )
}